import React from 'react'
import { Box, Card, CardContent, IconButton, Skeleton, useMediaQuery, useTheme } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { useStyles } from './style'

const AuthorSkeleton = () => {
  return (
    <Card
      sx={{
        maxWidth: 280,
        border: '1px solid #eee',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 2,
        mx: 'auto'
      }}
    >
      <Box
        sx={{
          width: 200,
          height: 248,
          overflow: 'hidden',
          marginBottom: 1
        }}
      >
        <Skeleton
          variant='rectangular'
          width='100%'
          height='100%'
          sx={{
            borderRadius: 1
          }}
        />
      </Box>

      <CardContent
        sx={{
          textAlign: 'center',
          width: '100%'
        }}
      >
        <Skeleton
          variant='text'
          width='80%'
          height={32}
          sx={{
            marginBottom: 1,
            marginX: 'auto'
          }}
        />
        <Skeleton
          variant='text'
          width='60%'
          height={20}
          sx={{
            marginBottom: 2,
            marginX: 'auto'
          }}
        />
        <Skeleton
          variant='rectangular'
          width={100}
          height={32}
          sx={{
            borderRadius: 2,
            marginX: 'auto'
          }}
        />
      </CardContent>
    </Card>
  )
}

export const AuthorsLoading = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const skeletonAuthors = Array.from({ length: 5 }, (_, index) => ({
    id: `skeleton-${index}`
  }))

  const itemsPerView = isMobile ? 1 : 4
  const showNavigation = skeletonAuthors.length > itemsPerView
  const showLeftArrow = showNavigation && false
  const showRightArrow = showNavigation && true

  return (
    <Box
      className={`${classes.carouselContainer}`}
      role='region'
      aria-label='Authors carousel loading'
    >
      {showLeftArrow && (
        <IconButton
          className={classes.carouselButton}
          disabled
          aria-label='Previous authors'
        >
          <ChevronLeft />
        </IconButton>
      )}

      <Box className={classes.carouselContent}>
        <Box className={classes.carouselSlides}>
          <Box className={classes.cardsContainer}>
            {skeletonAuthors.map(author => (
              <AuthorSkeleton key={author.id} />
            ))}
          </Box>
        </Box>
      </Box>
      {showRightArrow && (
        <IconButton
          className={classes.carouselButton}
          disabled
          aria-label='Next authors'
        >
          <ChevronRight />
        </IconButton>
      )}
    </Box>
  )
}
